module.exports = __webpack_public_path__ + "static/media/RecordsIcom.dfb6f335.svg";